export default "__VITE_ASSET__1a436ef3__"